var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-center align-center" },
    [
      _c("va-button", {
        staticStyle: { "background-color": "black", width: "180px" },
        attrs: {
          icon: "vi vi-microsoft",
          color: "secondary darken-2",
          cta: _vm.signup
            ? _vm.$t("mfa.signUpMicrosoft")
            : _vm.$t("mfa.signInMicrosoft")
        },
        on: { click: _vm.handleSignIn }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }